// Reopening a closed matter — Reopen Matter on the matter page, a status
// change on the edit form, or the Matters list's status badge — clears the
// closing record (close date, closing notes, pre-close checklist; the API runs
// one shared reopen, api/src/lib/matterStatus.js reopenMatter).  Every one of
// them asks first, in the same words (round-3 review, 2026-10-20).  The last
// sentence is the API's REOPEN_CLEARS_SENTENCE; matterStatusRules.test.js
// fails if the two drift apart.
export const REOPEN_CLEARS_SENTENCE =
  'Reopening clears its close date, closing notes and pre-close checklist; the Audit Log keeps the matter as it was before the reopen.'

// The useAsk() options for that confirmation.  `toStatus` is the status the
// matter reopens to ('active' unless the edit form or badge picked 'pending').
export function reopenConfirmOptions (toStatus = 'active') {
  const label = toStatus === 'pending' ? 'Pending' : 'Active'
  return {
    type: 'confirm',
    title: 'Reopen matter?',
    message: `Reopen this matter? It will be set back to ${label}. ${REOPEN_CLEARS_SENTENCE}`,
    confirmLabel: 'Reopen',
    danger: true,
  }
}
